import { render, staticRenderFns } from "./Marquee.vue?vue&type=template&id=3a767d42&"
import script from "TY/components/home/marquee.component?vue&type=script&lang=js&"
export * from "TY/components/home/marquee.component?vue&type=script&lang=js&"
import style0 from "./Marquee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports